/* Pose ta question : suggestions qui préremplissent le message, variante et page à jour à l'envoi. */
(function () {
  /* Ajoute une suggestion au message sans écraser ce que le client a déjà écrit. */
  function ajouter(actuel, suggestion) {
    var texte = (actuel || '').replace(/\s+$/, '');
    if (!texte) return suggestion + ' ';
    if (texte.indexOf(suggestion) !== -1) return texte;
    return texte + '\n' + suggestion + ' ';
  }

  /* Variante choisie, lue dans le sélecteur de la fiche produit. */
  function varianteChoisie() {
    var select = document.querySelector('[data-variantes]');
    if (select && select.selectedIndex > -1) {
      var option = select.options[select.selectedIndex];
      return { id: select.value, titre: option.textContent.replace(/\s*\(rupture\)\s*$/, '').trim() };
    }
    var champ = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return champ ? { id: champ.value, titre: '' } : null;
  }

  function brancher(zone) {
    Array.prototype.forEach.call((zone || document).querySelectorAll('.apq'), function (section) {
      if (section.__apq) return;
      section.__apq = true;
      var message = section.querySelector('[data-question-message]');
      var form = message ? message.form : null;

      Array.prototype.forEach.call(section.querySelectorAll('[data-question-suggestion]'), function (b) {
        b.addEventListener('click', function () {
          if (!message) return;
          message.value = ajouter(message.value, b.textContent.trim());
          message.focus();
          var fin = message.value.length;
          try { message.setSelectionRange(fin, fin); } catch (e) {}
        });
      });

      if (form) {
        form.addEventListener('submit', function () {
          var page = section.querySelector('[data-question-page]');
          var champVariante = section.querySelector('[data-question-variante]');
          var v = varianteChoisie();
          if (page) {
            try {
              var url = new URL(window.location.origin + window.location.pathname);
              if (v && v.id) url.searchParams.set('variant', v.id);
              page.value = url.toString();
            } catch (e) {}
          }
          if (champVariante && v && v.titre) champVariante.value = v.titre;
        });
      }

      /* Après l'envoi, on amène le client sur le message de confirmation. */
      var ok = section.querySelector('[data-question-ok]');
      if (ok) {
        ok.scrollIntoView({ block: 'center' });
        try { ok.focus({ preventScroll: true }); } catch (e) {}
      }
    });
  }

  window.AspadelQuestion = { ajouter: ajouter };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { brancher(); });
  else brancher();
  document.addEventListener('shopify:section:load', function (e) { brancher(e.target); });
})();
